import { NgForOf } from "@angular/common";
import { Directive, Host, Input, type NgIterable } from "@angular/core";

@Directive({
    // tslint:disable-next-line: directive-selector
    selector: '[ngForTrackByIndex]',
    standalone: false
})
export class NgForTrackByIndexDirective<T> {

    @Input() ngForOf!: NgIterable<T>;

    constructor(@Host() ngForOfDir: NgForOf<T>) {
        ngForOfDir.ngForTrackBy = (index: number): number => index;
    }
}